/**
 * Prefetch lazy route chunks so CTA clicks paint sooner (INP).
 * Safe no-ops if webpack already has the module.
 */

type PrefetchKey = 'start' | 'how-it-works' | 'why-us' | 'roadmap' | 'agentic';

const loaders: Record<PrefetchKey, () => Promise<unknown>> = {
  start: () => import('../pages/SelectUseCasePage'),
  'how-it-works': () => import('../pages/HowItWorksPage'),
  'why-us': () => import('../pages/WhyUsPage'),
  roadmap: () => import('../pages/RoadmapPage'),
  agentic: () => import('../pages/AgenticAssessment'),
};

const warmed = new Set<PrefetchKey>();

export function prefetchRoute(key: PrefetchKey): void {
  if (warmed.has(key)) return;
  warmed.add(key);
  void loaders[key]().catch(() => {
    warmed.delete(key);
  });
}

/** Warm marketing entry chunks after first paint / on idle. */
export function prefetchMarketingRoutesIdle(): void {
  const run = () => {
    prefetchRoute('start');
    prefetchRoute('how-it-works');
    prefetchRoute('why-us');
  };
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(() => run(), { timeout: 2500 });
  } else {
    setTimeout(run, 400);
  }
}

/** Defer non-critical work until after the next paint (helps INP). */
export function afterNextPaint(fn: () => void): void {
  if (typeof window === 'undefined') {
    fn();
    return;
  }
  requestAnimationFrame(() => {
    setTimeout(fn, 0);
  });
}
